var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import clsx from 'clsx';
import { XBox } from '../box/XBox';
import { useImmer } from 'use-immer';
import { XButton } from '../button/XButton';
export function XFormInputContainer(input) {
    var label = input.label, placeholder = input.placeholder, helperText = input.helperText, adornmentStart = input.adornmentStart, adornmentStartIcon = input.adornmentStartIcon, adornmentEnd = input.adornmentEnd, adornmentEndIcon = input.adornmentEndIcon, ref = input.ref, disabled = input.disabled, className = input.className, children = input.children;
    var id = useState(input.id || Math.random().toString())[0];
    var _a = useImmer({
        interacted: false,
        changed: false,
    }), inputState = _a[0], setInputState = _a[1];
    var hasAdornmentStart = Boolean(adornmentStart || adornmentStartIcon);
    var hasAdornmentEnd = Boolean(adornmentEnd || adornmentEndIcon);
    return (React.createElement("label", { htmlFor: id, className: clsx('XFormInputContainer', className, __assign({ hasAdornmentStart: hasAdornmentStart,
            hasAdornmentEnd: hasAdornmentEnd,
            disabled: disabled }, inputState)) },
        label && React.createElement("div", { className: "label" }, label),
        React.createElement(XBox, { flex: true, align: "center", className: "input-container" },
            hasAdornmentStart && (React.createElement("div", { className: "adornment start" },
                adornmentStart,
                adornmentStartIcon && React.createElement(XButton, { icon: adornmentStartIcon }))),
            children,
            hasAdornmentEnd && (React.createElement("div", { className: "adornment end" },
                adornmentEnd,
                adornmentEndIcon && React.createElement(XButton, { icon: adornmentEndIcon })))),
        helperText && React.createElement("div", { className: 'helperText' }, helperText)));
}
